var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-center",staticStyle:{"margin-top":"100px"}},[_vm._v("\n        Importation de données\n    ")])])
}]

export { render, staticRenderFns }